import {
  Filter,
  SelectInput,
  AutocompleteInput,
  TextInput,
  useDataProvider,
  Loading,
  useListContext,
} from 'react-admin'
import { ActionTitles, IDENTITY_VERIFICATION_REQUEST_STATUS_CHOICES, ORDER_KEYS, RESOURCES, SCREENING_MATCH_STATUS_CHOICES, WATCHLIST_COLUMN_KEYS } from "../Constants";
import { useEffect, useState } from "react";
import { width } from '../Styles'
import { parseRequestingUserNameChoicesForAdmins, parseRequestingUserNameChoicesForClients } from '../../mappers/Report';
import { Error404 } from '../errors/Error404';
import DatePickerInput from '../common/DatePickerInputForFilter';
import {   
   Switch,
   FormControlLabel,
   FormGroup,
} from '@mui/material';
import {  
  useListSortContext,
  useStore,   
} from 'ra-core';

export const IdentityFilter = (props) => {

  return (
    <Filter {...props}>
      <TextInput
        label="Search"
        source="searchValue"
        size="small"
        variant="outlined"
        alwaysOn
        resettable
        sx={width.fixed.w200}
      />
      <AutocompleteInput
        id="identity-filter-requesting-user"
        label="Requesting User Name"
        source="requestingUserId"
        choices={parseRequestingUserNameChoicesForClients(props.requestingUserNames)}
        variant="outlined"
        size="small"
        sx={width.fixed.w250}
        resettable
        alwaysOn
      />
      <SelectInput
        id="identity-filter-match-status"
        label="Match Status"
        source="screeningMatchStatus"
        choices={SCREENING_MATCH_STATUS_CHOICES}
        size="small"
        variant="outlined"
        alwaysOn
      />
      <DatePickerInput
        label="Event Before Date"
        source="oldestUnacknowledgedEventTime"
        size="small"
        variant="outlined"
        alwaysOn
        resettable
      />
      <LiveMonitoringFilter
        label="Live Monitoring"
        source="liveMonitoring"
        size="medium"
        variant="outlined"
        alwaysOn
      />
    </Filter>
  );
};

export const IdentityAdminFilter = (props) => {
  const { setClientId } = props;
  var partnerChoices = [];
  const dataProvider = useDataProvider();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const { filterValues, setFilters } = useListContext();  

  //When client is changed, reset requestingUserId
  useEffect(() => {
    setClientId(filterValues.clientId);
    setFilters({ ...filterValues, requestingUserId: "" }, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues.clientId]);

  useEffect(() => {
    dataProvider
      .getClientNameList("admin/client/names")
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [dataProvider]);

  if (loading) return <Loading />;
  if (error) return <Error404 />;
  partnerChoices = data;

  return (
    <Filter variant="outlined" {...props}>
      <AutocompleteInput
        id="identity-admin-filter-client"
        source="clientId"
        name="clientId" //check this while integration
        variant="outlined"
        size="small"
        label={ActionTitles.CORPORATE_PARTNER}
        choices={partnerChoices}
        resettable
        sx={width.fixed.w200}
        alwaysOn
      />
      <TextInput
        label="Search"
        source="searchValue"
        size="small"
        variant="outlined"
        alwaysOn
        resettable
        sx={width.fixed.w200}
      />
      <SelectInput
        id="identity-admin-filter-status"
        label="Status"
        source="status"
        choices={IDENTITY_VERIFICATION_REQUEST_STATUS_CHOICES}
        size="small"
        variant="outlined"
        alwaysOn
      />
      <AutocompleteInput
        id="identity-admin-filter-requesting-user"
        label="Requesting User Name"
        source="requestingUserId"
        choices={parseRequestingUserNameChoicesForAdmins(
          props.requestingUserNames
        )}
        variant="outlined"
        size="small"
        sx={width.fixed.w250}
        resettable
        alwaysOn
      />
      <SelectInput
        id="identity-admin-filter-match-status"
        label="Match Status"
        source="screeningMatchStatus"
        choices={SCREENING_MATCH_STATUS_CHOICES}
        size="small"
        variant="outlined"
        alwaysOn
      />
      <DatePickerInput
        label="Event Before Date"
        source="oldestUnacknowledgedEventTime"
        size="small"
        variant="outlined"
        alwaysOn
        resettable
      />
      <LiveMonitoringFilter
        label="Live Monitoring"
        source="liveMonitoring"
        size="medium"
        variant="outlined"
        alwaysOn
      />
    </Filter>
  );
};

const LiveMonitoringFilter = (props) => {   
   const { setSort } = useListSortContext();
   const { filterValues,  setFilters } = useListContext();

   const columnsPrefernceKey = `preferences.${RESOURCES.IDENTITY_VERIFICATION}.datagrid.availableColumns`;
   const columnsIndexPrefernceKey = `preferences.${RESOURCES.IDENTITY_VERIFICATION}.datagrid.columns`;

   const [availableColumns] = useStore(columnsPrefernceKey, []);
   // eslint-disable-next-line no-unused-vars
   const [columnsIndex, setColumnsIndex] = useStore(columnsIndexPrefernceKey, []);


   const handleChange = (event) => {
    const state = event.target.checked;

    if (state) { // We're hiding Monitoring End, Created, and Last Modified field based on the filter value            
      setColumnsIndex(getLiveMonitoringIndexView(availableColumns));
      setSort({
        field: WATCHLIST_COLUMN_KEYS.DAYS_TO_RENEWAL,
        order: ORDER_KEYS.ASC,
      });
    } else {
      setColumnsIndex(getNormalIndexView(availableColumns));
      setSort({
        field: WATCHLIST_COLUMN_KEYS.UPDATED_AT,
        order: ORDER_KEYS.DESC,
      });
    }

    setFilters({ ...filterValues, liveMonitoring: state }, undefined, false);
};
  
   return (
    <FormGroup>
      <FormControlLabel                    
        control={
          <Switch
            id="identity-filter-live-monitoring-switch"
            name="liveMonitoring"
            onChange={handleChange}
            defaultChecked={filterValues.liveMonitoring}
            {...props}                                        
          />
        }
        label="Live Monitoring"
      />                
  </FormGroup>    
  );
};

const getLiveMonitoringIndexView = (columns) => {
  return columns
    .filter((column) =>
      column.source !== WATCHLIST_COLUMN_KEYS.CM_FINISHED_AT &&
      column.source !== WATCHLIST_COLUMN_KEYS.CREATED_AT &&
      column.source !== WATCHLIST_COLUMN_KEYS.UPDATED_AT      
    )
    .map((column) => column.index);
}

const getNormalIndexView = (columns) => {
  return columns.map((column) => column.index);
}